const ACCOUNT_SHELL_STORAGE_PREFIX = "app:accountShell:contract:";
const ACCOUNT_SHELL_CONTRACT_VERSION = "modules-permissions-v2";

function getAccountShellStorageKey(accountId) {
  const normalizedAccountId = String(accountId || "").trim();
  return normalizedAccountId
    ? `${ACCOUNT_SHELL_STORAGE_PREFIX}${normalizedAccountId}`
    : "";
}

export function hasCurrentAccountShellContract(accountId) {
  if (typeof window === "undefined") return true;

  const key = getAccountShellStorageKey(accountId);
  if (!key) return false;

  return window.localStorage.getItem(key) === ACCOUNT_SHELL_CONTRACT_VERSION;
}

export function markCurrentAccountShellContract(accountId) {
  if (typeof window === "undefined") return;

  const key = getAccountShellStorageKey(accountId);
  if (!key) return;

  window.localStorage.setItem(key, ACCOUNT_SHELL_CONTRACT_VERSION);
}
